import { useEffect } from 'react';

export default function useLocalStorage(localStorageKey: string, value: boolean | string) {
  useEffect(
    () => void localStorage.setItem(localStorageKey, String(value)),
    [localStorageKey, value],
  );
}
